module.exports = __webpack_public_path__ + "media/assets/icon_email-f04a6648668bbe2a0ea9678de82fdd5ee7896a555e9e710f2b28590714375c12.svg";